// Storage utility functions for JWT token persistence

const TOKEN_KEY = 'insta_jwt_token';
const USER_KEY = 'insta_logged_in_user';
const SERVICE_TYPES_KEY = 'insta_service_types';
const PRACTICE_KEY = 'insta_practice_details';

/**
 * Save JWT token to localStorage
 */
export const saveToken = (token) => {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch (error) {
    console.error('Failed to save token to localStorage:', error);
  }
};

/**
 * Retrieve JWT token from localStorage
 */
export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY) || null;
  } catch (error) {
    console.error('Failed to retrieve token from localStorage:', error);
    return null;
  }
};

/**
 * Save logged-in user data to localStorage
 */
export const saveUser = (user) => {
  try {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  } catch (error) {
    console.error('Failed to save user to localStorage:', error);
  }
};

/**
 * Retrieve logged-in user data from localStorage
 */
export const getUser = () => {
  try {
    const user = localStorage.getItem(USER_KEY);
    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.error('Failed to retrieve user from localStorage:', error);
    return null;
  }
};

/**
 * Save service types to localStorage
 */
export const saveServiceTypes = (serviceTypes) => {
  try {
    localStorage.setItem(SERVICE_TYPES_KEY, JSON.stringify(serviceTypes));
  } catch (error) {
    console.error('Failed to save service types to localStorage:', error);
  }
};

/**
 * Retrieve service types from localStorage
 */
export const getServiceTypes = () => {
  try {
    const types = localStorage.getItem(SERVICE_TYPES_KEY);
    return types ? JSON.parse(types) : [];
  } catch (error) {
    console.error('Failed to retrieve service types from localStorage:', error);
    return [];
  }
};

/**
 * Clear all authentication data from localStorage
 */
export const clearAuthData = () => {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(SERVICE_TYPES_KEY);
    localStorage.removeItem(PRACTICE_KEY);
    console.log('Cleared auth data from localStorage');
  } catch (error) {
    console.error('Failed to clear auth data from localStorage:', error);
  }
};

/**
 * Save practice details to localStorage
 */
export const savePracticeDetails = (practice) => {
  try {
    localStorage.setItem(PRACTICE_KEY, JSON.stringify(practice));
  } catch (error) {
    console.error('Failed to save practice details to localStorage:', error);
  }
};

/**
 * Retrieve practice details from localStorage
 */
export const getPracticeDetails = () => {
  try {
    const practice = localStorage.getItem(PRACTICE_KEY);
    return practice ? JSON.parse(practice) : null;
  } catch (error) {
    console.error('Failed to retrieve practice details from localStorage:', error);
    return null;
  }
};

/**
 * Check if user has a valid token in storage
 */
export const hasValidToken = () => {
  const token = getToken();
  return token && token.length > 0;
};
